import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Contact } from "@/pages/contact";
import { Home } from "@/pages/home";
import { NotFound } from "@/pages/not-found";
import { Projects } from "@/pages/projects";
import { Resume } from "@/pages/resume";

import { Providers } from "./providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main className="min-h-screen bg-background">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
